import TimelineItem from '../project-timeline/TimelineItem';
import { descriptionToHtmlObject } from '../../utils/html-utils';
import DescriptionWrapper from '../../components/description-wrapper/DescriptionWrapper';
import CollapseChildren from '../../components/collapse-children/CollapseChildren';
import styles from './timeline.module.less';

const ExpandableTimelineItem = ({ title, subtitle, expandedInfo, tag, id }) => {
    const descriptionObject = descriptionToHtmlObject(expandedInfo);

    const expandableDescription = (
        <CollapseChildren expandButtonText="Vis hele oppdateringen" mobileOnly={true} canClose={false} maxHeight={200}>
            <DescriptionWrapper>
                <div className={styles.descriptionContainer} dangerouslySetInnerHTML={descriptionObject} />
            </DescriptionWrapper>
        </CollapseChildren>
    );

    return <TimelineItem title={title} subtitle={subtitle} description={expandableDescription} tag={tag} id={id} />;
};

export default ExpandableTimelineItem;
